import FileSaver from 'file-saver';
import { PdfDocument } from './pdfTemplate/pdfTemplate';
import { pdf } from '@react-pdf/renderer';
import { CSVIcon, ExcelIcon, PDFIcon } from '../icons/files';

export const generatePdfInvoice = async (documentData, title) => {
  try {
    const universalBOM = '\uFEFF';
    const pdfTitle = title ? universalBOM + title : '';
    const blob = await pdf(
      <PdfDocument
        title={pdfTitle}
        tableData={documentData}
        orientation="landscape"
        customStyle={{
          blankSpace: {
            ΑΦΜ: { width: '15%' },
            'Όνομα αρχείου': { width: '30%' },
            Ημερομηνία: { width: '10%' },
            'Αριθμός Αρχείου': { width: '10%', textAlign: 'center' },
            'Τύπος Αρχείου': { width: '20%', textAlign: 'center' },
            Ποσό: { width: '15%', textAlign: 'center' },
          },
          header: {
            ΑΦΜ: { width: '15%' },
            'Όνομα αρχείου': { width: '30%' },
            Ημερομηνία: { width: '10%' },
            'Αριθμός Αρχείου': { width: '10%' },
            'Τύπος Αρχείου': { width: '20%' },
            Ποσό: { width: '15%' },
          },
          row: {
            ΑΦΜ: { width: '15%' },
            'Όνομα αρχείου': { width: '30%' },
            Ημερομηνία: { width: '10%' },
            'Αριθμός Αρχείου': { width: '10%', textAlign: 'center' },
            'Τύπος Αρχείου': { width: '20%', textAlign: 'center' },
            Ποσό: { width: '15%', textAlign: 'center' },
          },
        }}
      />
    ).toBlob();

    FileSaver.saveAs(blob, title);
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export const exportToExcel = (excelData, fileName) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  import('xlsx').then((xlsx) => {
    const ws = xlsx.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  });
};

export const exportToCSV = (data, fileName) => {
  const fileExtension = '.csv';
  import('xlsx').then((xlsx) => {
    const ws = xlsx.utils.json_to_sheet(data);
    const csv = xlsx.utils.sheet_to_csv(ws);

    const new_csv = '\uFEFF' + csv;
    const blob = new Blob([new_csv], { type: 'text/plain;charset=UTF-8' });
    FileSaver.saveAs(blob, fileName + fileExtension);
  });
};

export const exportToPdf = (args) => {
  import('pdfmake/build/pdfmake').then((pdfMake) => {
    import('pdfmake/build/vfs_fonts').then(async (pdfFonts) => {
      const fileExtension = '.pdf';
      const styles = args.styles;
      const fileName = args.fileName;
      const docProperty = args.docProperty;
      const width = args.width;
      const table = args.table;
      const doc = {
        ...docProperty,
        pageOrientation: 'landscape',
        pageSize: 'A4',
        pageMargins: [10, 20],
        content: [
          {
            text: fileName,
            style: 'title',
            margin: [0, 0, 0, 20],
          },
          {
            layout: {
              hLineColor: function (i, node) {
                return i === 1 ? '#d4002a' : 'white';
              },
              vLineColor: function (i, node) {
                return 'white';
              },
              hLineWidth: function (i, node) {
                return i === 1 ? 1 : 0;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
              fillColor: function (rowIndex, node, columnIndex) {
                if (rowIndex === 1) return null;
                return rowIndex % 2 === 0 ? '#faf9f9' : null;
              },
            },
            style: 'table',
            table: {
              widths: width,
              headerRows: 2,
              dontBreakRows: true,
              keepWithHeaderRows: 1,
              body: table,
            },
          },
        ],

        styles: {
          title: {
            fontSize: 22,
            bold: true,
            color: '#d4002a',
          },
          table: {
            fontSize: 6,
            // minWidth: 150
          },
          ...styles,
        },
      };

      const pdfDocGenerator = pdfMake.createPdf(doc);
      pdfDocGenerator.vfs = pdfFonts.pdfMake.vfs;
      pdfDocGenerator.fonts = {
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-Italic.ttf',
        },
      };

      pdfDocGenerator.download(fileName + fileExtension);
    });
  });
};

export const exportStatisticsToCSV = (data, fileName) => {
  const fileExtension = '.csv';
  import('xlsx').then((xlsx) => {
    const ws = xlsx.utils.aoa_to_sheet(data);
    const csv = xlsx.utils.sheet_to_csv(ws);

    const new_csv = '\uFEFF' + csv;
    const blob = new Blob([new_csv], { type: 'text/plain;charset=UTF-8' });
    FileSaver.saveAs(blob, fileName + fileExtension);
  });
};

export const exportStatisticsToXLS = (dataRows, fileName) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  import('xlsx').then((xlsx) => {
    const ws = xlsx.utils.aoa_to_sheet(dataRows);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  });
};

export const exportOptions = [
  { title: 'Excel', icon: <ExcelIcon width={20} height={20} />, type: 'xls' },
  { title: 'CSV', icon: <CSVIcon />, type: 'csv' },
  { title: 'PDF', icon: <PDFIcon />, type: 'pdf' },
];
